export const panMapToLatLng = (map, latLng) => map.panTo(latLng);
